var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_setup.bannerX && _setup.pageNum === 1)?_c(_setup.BannerX,{attrs:{"banner":_setup.bannerX}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }